import { endPoints } from "@/constants";
import * as apiService from "./apiService";

// Returns { mlsListings, prospects }. Note apiCall already unwraps axios, and
// the v2 envelope's payload key is also `data` — hence response.data.data.
export async function getEligibleProperties(query) {
  const response = await apiService.apiCall(
    endPoints.GET_INTRO_ELIGIBLE_PROPERTIES,
    "GET",
    query,
  );
  const data = response?.data ?? {};
  return {
    mlsListings: Array.isArray(data.mlsListings) ? data.mlsListings : [],
    prospects: Array.isArray(data.prospects) ? data.prospects : [],
    // True where the environment serves AI rankings; the picker then shows AI
    // scores only, instead of falling back to the matcher score.
    aiDisplay: !!data.aiDisplay,
    intake: data.intake || null,
  };
}
